import React from 'react';
import { Box, Container, Typography, Paper, Grid } from '@mui/material';
import Logo from '../components/Logo';

const LogoDemo: React.FC = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h3" component="h1" gutterBottom align="center">
        TotalBat Logo Design
      </Typography>
      
      <Typography variant="h6" color="text.secondary" align="center" sx={{ mb: 6 }}>
        Construction Solutions - Professional & Reliable
      </Typography>

      {/* Logo Sizes */}
      <Box sx={{ mb: 6 }}>
        <Typography variant="h5" gutterBottom>
          Logo Sizes
        </Typography>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} sm={4}>
            <Paper sx={{ p: 3, textAlign: 'center' }}>
              <Typography variant="h6" gutterBottom>Small</Typography>
              <Logo size="small" />
            </Paper>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Paper sx={{ p: 3, textAlign: 'center' }}>
              <Typography variant="h6" gutterBottom>Medium</Typography>
              <Logo size="medium" />
            </Paper>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Paper sx={{ p: 3, textAlign: 'center' }}>
              <Typography variant="h6" gutterBottom>Large</Typography>
              <Logo size="large" />
            </Paper>
          </Grid>
        </Grid>
      </Box>

      {/* Logo Variations */}
      <Box sx={{ mb: 6 }}>
        <Typography variant="h5" gutterBottom>
          Logo Variations
        </Typography>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} sm={6}>
            <Paper sx={{ p: 3, textAlign: 'center' }}>
              <Typography variant="h6" gutterBottom>With Tagline</Typography>
              <Logo size="medium" showTagline={true} />
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Paper sx={{ p: 3, textAlign: 'center' }}>
              <Typography variant="h6" gutterBottom>Without Tagline</Typography>
              <Logo size="medium" showTagline={false} />
            </Paper>
          </Grid>
        </Grid>
      </Box>

      {/* Color Palette */}
      <Box sx={{ mb: 6 }}>
        <Typography variant="h5" gutterBottom>
          Brand Colors
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6} sm={3}>
            <Paper sx={{ p: 2, textAlign: 'center' }}>
              <Box 
                sx={{ 
                  width: 60, 
                  height: 60, 
                  backgroundColor: '#1E40AF', 
                  borderRadius: 1,
                  mx: 'auto',
                  mb: 1
                }} 
              />
              <Typography variant="body2">Primary Blue</Typography>
              <Typography variant="caption" color="text.secondary">#1E40AF</Typography>
            </Paper>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Paper sx={{ p: 2, textAlign: 'center' }}>
              <Box 
                sx={{ 
                  width: 60, 
                  height: 60, 
                  backgroundColor: '#3B82F6', 
                  borderRadius: 1,
                  mx: 'auto',
                  mb: 1
                }} 
              />
              <Typography variant="body2">Secondary Blue</Typography>
              <Typography variant="caption" color="text.secondary">#3B82F6</Typography>
            </Paper>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Paper sx={{ p: 2, textAlign: 'center' }}>
              <Box 
                sx={{ 
                  width: 60, 
                  height: 60, 
                  backgroundColor: '#EA580C', 
                  borderRadius: 1,
                  mx: 'auto',
                  mb: 1
                }} 
              />
              <Typography variant="body2">Construction Orange</Typography>
              <Typography variant="caption" color="text.secondary">#EA580C</Typography>
            </Paper>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Paper sx={{ p: 2, textAlign: 'center' }}>
              <Box 
                sx={{ 
                  width: 60, 
                  height: 60, 
                  backgroundColor: '#64748B', 
                  borderRadius: 1,
                  mx: 'auto',
                  mb: 1
                }} 
              />
              <Typography variant="body2">Neutral Gray</Typography>
              <Typography variant="caption" color="text.secondary">#64748B</Typography>
            </Paper>
          </Grid>
        </Grid>
      </Box>

      {/* Design Features */}
      <Box>
        <Typography variant="h5" gutterBottom>
          Design Features
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <Paper sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>🏗️ Foundation Icon</Typography>
              <Typography variant="body2" color="text.secondary">
                Represents the solid foundation and structural integrity that TotalBat provides in construction projects.
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={4}>
            <Paper sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>🎨 Professional Colors</Typography>
              <Typography variant="body2" color="text.secondary">
                Blue conveys trust and professionalism, while orange represents energy and construction industry.
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={4}>
            <Paper sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>📱 Responsive Design</Typography>
              <Typography variant="body2" color="text.secondary">
                Scalable SVG format ensures crisp display at any size, from mobile to large displays.
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default LogoDemo; 